<script setup lang="ts">
    import { OrthographicCamera } from 'three';
    import { stopAll } from '@/util';
    import {
        updateXRayScene,
        xraySceneContext,
        type XRayViewportId,
    } from '@/views/dicoms/xrays/xrayScene';
    import { useXRaysStore } from '@/views/dicoms/xrays/xraysViewStore';
    import { useScene } from '@/lib/threeScene/scene/useScene';
    import { attachRenderingState } from '@/lib/threeScene/scene/attachRenderingState';

    const props = defineProps<{ viewportId: XRayViewportId; title: string }>();

    const store = useXRaysStore();

    const { containerRef, canvasRef } = useScene({
        camera: () => new OrthographicCamera(),
        sceneContext: () => xraySceneContext(store.sceneState(props.viewportId)),
        setup: ({ canvas, container, sceneContext, camera, runtime }) => stopAll(
            updateXRayScene(sceneContext, props.viewportId),
            attachRenderingState({
                runtime,
                state: sceneContext.state.rendering,
                scene: sceneContext.scene,
                camera,
                container,
                canvas,
            }),
        ),
    });
</script>

<template>
    <div ref="containerRef" class="viewport-container d-flex flex-column-reverse align-start">
        <canvas ref="canvasRef" class="viewport-canvas overflow-hidden position-absolute" />
        <div class="title">{{title}}</div>
    </div>
</template>

<style scoped lang="scss">
    .title {
        color: black;
        background: #fffa;
        padding: 10px 30px 10px 20px;
        border-top-right-radius: 12px;
        text-transform: none;
        font-size: 12px;
        z-index: 1000;
    }
</style>
